import ArchiveOutlined from '@mui/icons-material/ArchiveOutlined';
import { t } from 'i18next';

import MessagingTag from '~pages/Messages/components/MessagingTag';

export default function MessagingArchivedTag() {
  return (
    <MessagingTag
      icon={<ArchiveOutlined aria-hidden sx={{ fontSize: '13px' }} />}
      label={t('messaging.archived')}
      testId="messaging-archived-tag"
      tone="info"
    />
  );
}
